import React, { memo } from 'react';
import { styledComponent, lineHeightStyle } from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';

const PediatricHistoryView = ({
    selectedHistories,
    setSelectedHistories,
    prescriptionItems,
    isHistoryPage,
    removeItemsData,
}) => {
    const Title = styledComponent(
        prescriptionItems?.items?.['history']?.itemStyle || {},
    );
    const Value = styledComponent(
        prescriptionItems?.items?.['history']?.subItemStyle || {},
    );

    const pediatric = selectedHistories?.pediatric || {};

    const handleDeleteField = (fieldName) => {
        const updatedPediatric = { ...pediatric };
        delete updatedPediatric[fieldName];

        const updatedHistories = {
            ...selectedHistories,
            pediatric: updatedPediatric
        };

        setSelectedHistories(updatedHistories);
    };

    // Handle deletion of a specific birth history item
    const handleDeleteBirthHistoryItem = (index) => {
        const birthHistory = [...pediatric.birthHistory];
        birthHistory.splice(index, 1);

        const updatedPediatric = { ...pediatric };
        if (birthHistory.length === 0) {
            delete updatedPediatric.birthHistory;
        } else {
            updatedPediatric.birthHistory = birthHistory;
        }

        const updatedHistories = {
            ...selectedHistories,
            pediatric: updatedPediatric
        };

        setSelectedHistories(updatedHistories);
    };

    return (
        <>
            <div className="his-sub-title">Pediatric History</div>
            <ul style={lineHeightStyle('history', prescriptionItems)}>
                {/* Birth History Section */}
                {((Array.isArray(pediatric?.birthHistory) && pediatric.birthHistory.length > 0) || pediatric?.birthNote) && (
                    <li className='mb-1'>
                        {Array.isArray(pediatric.birthHistory) && pediatric.birthHistory.length > 0 && (
                            <div>
                                <span className="text-left pr-5">
                                    <Title>Birth History: </Title>
                                </span>
                                {/* {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={() => handleDeleteField('birthHistory')}
                                        itemName="birth history"
                                        isDelBtn={!isHistoryPage}
                                    />
                                )} */}
                                <ul className="pl-3 mb-0">
                                    {pediatric.birthHistory.map((item, index) => (
                                        <li key={index} className="text-left">
                                            <Value> {item}</Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => handleDeleteBirthHistoryItem(index)}
                                                    itemName={`birth history item "${item}"`}
                                                    isDelBtn={!isHistoryPage}
                                                />
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* For string birthHistory (backward compatibility) */}
                        {!Array.isArray(pediatric.birthHistory) && pediatric.birthHistory && (
                            <div>
                                <span className="text-left pr-5">
                                    <Title>Birth History: </Title>
                                    <Value>{pediatric.birthHistory}</Value>
                                </span>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={() => handleDeleteField('birthHistory')}
                                        itemName="birth history"
                                        isDelBtn={!isHistoryPage}
                                    />
                                )}
                            </div>
                        )}

                        {pediatric.birthNote && (
                            <div>
                                <span className="text-left pr-5">
                                    {!pediatric.birthHistory && <Title>Birth Note: </Title>}
                                    <Value>{pediatric.birthHistory ? '- ' : ''}{pediatric.birthNote}</Value>
                                </span>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={() => handleDeleteField('birthNote')}
                                        itemName="birth note"
                                        isDelBtn={!isHistoryPage}
                                    />
                                )}
                            </div>
                        )}
                    </li>
                )}

                {/* Immunization Section */}
                {(pediatric?.immunizationStatus || pediatric?.immunizationNote) && (
                    <li className='mb-1'>
                        {pediatric.immunizationStatus && (
                            <span className="text-left pr-5">
                                <Title>Immunization Status: </Title>
                                <Value>{pediatric.immunizationStatus}</Value>
                            </span>
                        )}

                        {pediatric.immunizationStatus && !isHistoryPage && (
                            <CommonDeleteBtn
                                action={() => handleDeleteField('immunizationStatus')}
                                itemName="immunization status"
                                isDelBtn={!isHistoryPage}
                            />
                        )}

                        {pediatric.immunizationNote && !pediatric.immunizationStatus && (
                            <div>
                                <span className="text-left pr-5">
                                    <Title>Immunization Note: </Title>
                                    <Value>{pediatric.immunizationNote}</Value>
                                </span>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={() => handleDeleteField('immunizationNote')}
                                        itemName="immunization note"
                                        isDelBtn={!isHistoryPage}
                                    />
                                )}
                            </div>
                        )}

                        {pediatric.immunizationNote && pediatric.immunizationStatus && (
                            <div>
                                <span className="text-left pl-2">
                                    <Value>- {pediatric.immunizationNote}</Value>
                                </span>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={() => handleDeleteField('immunizationNote')}
                                        itemName="immunization note"
                                        isDelBtn={!isHistoryPage}
                                    />
                                )}
                            </div>
                        )}
                    </li>
                )}

                {/* Past Illness Section */}
                {pediatric.pastIllnessNote && (
                    <li className="text-left">
                        <Title>Past Illness: </Title>
                        <Value>{pediatric.pastIllnessNote}</Value>
                        {!isHistoryPage && (
                            <CommonDeleteBtn
                                action={() => handleDeleteField('pastIllnessNote')}
                                itemName="Past Illness"
                                delId="pastIllnessNote"
                            />
                        )}
                    </li>
                )}

                {/* Development History Section */}
                {pediatric.developmentNote && (
                    <li className="text-left">
                        <Title>Development History: </Title>
                        <Value>{pediatric.developmentNote}</Value>
                        {!isHistoryPage && (
                            <CommonDeleteBtn
                                action={() => handleDeleteField('developmentNote')}
                                itemName="Development History"
                                delId="developmentNote"
                            />
                        )}
                    </li>
                )}

                {/* Physical/Neurological Findings Section */}
                {pediatric.physicalNote && (
                    <li className="text-left">
                        <Title>Physical/Neurological Findings: </Title>
                        <Value>{pediatric.physicalNote}</Value>
                        {!isHistoryPage && (
                            <CommonDeleteBtn
                                action={() => handleDeleteField('physicalNote')}
                                itemName="Physical/Neurological Findings"
                                delId="physicalNote"
                            />
                        )}
                    </li>
                )}
            </ul>
        </>
    );
};

export default memo(PediatricHistoryView);